import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import "./pagination.css";
import { PaginationSnippet } from "../../snippets/PaginationSnippet/PaginationSnippet.js";
import Card from "../Card/Card";
import { Copy } from "lucide-react";

const Pagination = ({ totalPages = 8, defaultPage = 4 }) => {
  const snippetContainerRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);

  const copySnippet = () => {
    if (snippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(snippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };
  const [currentPage, setCurrentPage] = useState(defaultPage);

  // helper to update page with wrap-around
  const setActive = (page) => {
    if (page < 1) page = totalPages;       // wrap to last
    if (page > totalPages) page = 1;       // wrap to first
    setCurrentPage(page);
  };
  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="carve-lean-body">
        <div className="carve-line">
          <div className="box-12">
            <div className="carve-button-group d-stretch carve-space-top-hefty carve-space-bottom-hefty">
              <button className="carve-button-main carve-wall-none" id="prev" onClick={() => setActive(currentPage - 1)}>❮</button>
              <div className="carve-button-group" id="pagination">
                {Array.from({ length: totalPages }, (_, idx) => {
                  const page = idx + 1;
                  return (
                    <button
                      key={page}
                      className={`carve-button-vice ${currentPage === page ? "active" : ""
                        }`}
                      onClick={() => setActive(page)}
                    >
                      {page}
                    </button>
                  );
                })}
              </div>
              <button className="carve-button-main carve-wall-none" id="next" onClick={() => setActive(currentPage + 1)}>❯</button>
            </div>
          </div>
        </div>
      </div>
      <div className={`center-container ${showScanning ? "scanning" : ""}`}>
        <div className="snippet" ref={snippetContainerRef}>
          <PaginationSnippet />
        </div>
        <button aria-label="Copy Button" onClick={copySnippet}>
          <Copy/>
        </button>
      </div>
    </motion.div>
  );
};
const PaginationCard = () => {
  return (
    <Card CardTitle="Pagination"
      CardBody={<Pagination />}
    />
  );
};

export default PaginationCard;
